export default __webpack_public_path__ + "static/media/gradu.fc9055b0.jpg";